<template>
  <div>
    <Form :description-title="'Registre uma nova noticia'">
      <CreateButton
        @click="registerSector()"
        :icon="PhCloudCheck"
        :label="'Registrar'"
      />
    </Form>
  </div>
</template>

<script setup>
import CreateButton from '@/components/Buttons/Create.vue'
import Form from '../components/RegisterForm.vue'
import {
  cleanAllFormFields,
  setFormFieldsError,
  validateFormField
} from '@/helpers/formFieldsHandler'
import { showToast as toast } from '@/helpers/UseToasts'
import { dataExtinguisher } from '../store'
import { storeApp } from '@/store'
import { onBeforeMount } from 'vue'
import * as yup from '@/validator'
import { PhCloudCheck } from '@phosphor-icons/vue'
import ExtinguisherService from '../service/extinguisher.service'

const store = dataExtinguisher.state
const appStore = storeApp.state

const schema = yup.object().shape({
  sectorForm: yup.object().shape({
    title: yup.string().required('Informe um titulo').label('Titulo')
  })
})

async function registerSector () {
  appStore.loading = true

  cleanAllFormFields()
  const validate = (await validateFormField(schema, store))

  if (validate && validate.length > 0) {
    setFormFieldsError(validate)
    appStore.loading = false
    return
  }

  if (
    store.sectorForm.image &&
    typeof store.sectorForm.image === 'object' &&
    typeof store.sectorForm.imageName === 'string'
  ) {
    await ExtinguisherService.saveImage(store.sectorForm.image)
      .then((res) => {
        store.sectorForm.banner = process.env.VUE_APP_IMAGE_SERVE + 'storage/' + res.data
      })
      .catch((err) =>
        toast(
          'Aviso',
          'Imagem não foi salva',
          'error'
        )
      )
  } else {
    store.sectorForm.imageName = null
    store.sectorForm.image = null
  }

  delete store.sectorForm.image
  delete store.sectorForm.imageName
  delete store.sectorForm?.id

  store.sectorForm.author = localStorage.getItem('__uuid') ?? null

  await ExtinguisherService.registerNotice(store.sectorForm)
    .then(res => {
      appStore.loading = false

      if (res?.data?.success) {
        dataExtinguisher.dispatch('addNewSectorCollect', res?.data?.notice)

        toast(
          'Sucesso',
          res.data.message,
          'success'
        )

        dataExtinguisher.dispatch('resetForm')
      }
    }).catch(err => {
      appStore.loading = false

      if (err?.response?.data?.error && err.response.data.status === 400) {
        return toast(
          'Aviso',
          err.response.data.message,
          'error'
        )
      }

      return toast(
        'Aviso',
        'Algo deu errado ao registrar documento',
        'error'
      )
    })
}

onBeforeMount(async () => {
  appStore.loading = true
  dataExtinguisher.commit('RESET_FORM')
  dataExtinguisher.dispatch('setBackComponent', 'SectorForm')
  appStore.loading = false
})
</script>
